export default __webpack_public_path__ + "static/media/project.3935e9cb.jpg";